import { getCarouselFooterItems } from 'services/apis/carousel-footer';
import { GET_CAROUSEL_FOOTER_ITEMS } from 'constants/carousel-footer';

export const getCarouselFooterAction = () => ({
  type: GET_CAROUSEL_FOOTER_ITEMS,
  payload: getCarouselFooterItems(),
});
